// extracted by mini-css-extract-plugin
export var textInput = "_he-0";